import {
  Accordion,
  TokenTextAppearance,
  Text,
} from '@volkswagen-onehub/components-core';
import React, {useContext, useState} from 'react';
import {useAppSelector} from '../../../../store/hooks';
import {
  TrackingContext,
  TrackingEvents,
} from '../../../../store/context/modules/TrackingContext';
interface DataInterface {
  data: string[];
  title: string;
}

const Data: React.FC<DataInterface> = ({title, data}) => {
  const trackCtx = useContext(TrackingContext);

  const vehicle = useAppSelector((state) => state.vehicle.value);

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const onOpen = () => {
    const openState = !isOpen;
    setIsOpen(openState);

    if (vehicle) {
      const link = {
        name:
          (vehicle.model as string).toUpperCase() +
          '-ACCORDION-' +
          (openState ? 'OPEN' : 'CLOSE'),
      };
      const filter = {
        name:
          (vehicle.model as string).toLocaleUpperCase() +
          ' ' +
          title.toUpperCase(),
      };

      let accordion: {groupItemName: string; groupItemState?: string} = {
        groupItemName:
          (vehicle.model as string).toUpperCase() + ' ' + title.toUpperCase(),
      };

      if (openState) {
        accordion = {...accordion, groupItemState: 'open'};
      }

      trackCtx?.init(
        openState
          ? TrackingEvents.ACCORDION_OPEN_CLICK
          : TrackingEvents.ACCORDION_CLOSE_CLICK,
        (vehicle.model as string).toUpperCase(),
        (vehicle.model as string).toUpperCase() +
          '-RESULT-ACCORDION-' +
          (openState ? 'OPEN' : 'CLOSE'),
        link,
        filter,
        accordion,
      );
    }
  };

  return (
    <Accordion
      id="minor-timelines"
      headline={
        <Text appearance={TokenTextAppearance.headline300} bold>
          {title}
        </Text>
      }
      isOpen={isOpen}
      onClick={onOpen}
    >
      {data?.map((d) => (
        <Text key={d}>{d}</Text>
      ))}
    </Accordion>
  );
};

export default Data;
